import React from 'react'

const HMI = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Industrial Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>HMI</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/hmi.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>HMI (Human-Machine Interface):</h2>
                        <p className="mbot25">
                            Our HMI solutions deliver intuitive interfaces for operators to interact with machinery
                            and control systems. We ensure that data is presented clearly, allowing for effective
                            monitoring and adjustments to maintain optimal performance.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HMI
